mutation PayCycleCreate($input: PayCycleCreateInput!) {
  payCycleCreate(input: $input) {
    payCycle {
      id
      __typename
      _urgencyLevel
      _rowTimestamp
      _pendingApprovers
      transactionType {
        description
        layoutType
        transactionType
      }
      _isDeletable
      paymentAccountId
      paymentAccount {
        name
        bankAccountNumber
      }
      _isAccountingEntry
      description
      defaultPaymentDate
      controlTotalAmount
      currency {
        isoCode
      }
      statusType {
        statusType
        approvalState
        _transactionIconStatus
      }
      _isTransactionCancelled
      _totalPayments
      _paymentCount
      businessUnit {
        name
      }
      corporatePeriodId
      _isStagedApprovalRequest
      _isApprovalDocumentsRequired
      _requiredApprovalDocuments
    }
  }
}
